import UsersQuarantined from './UsersQuarantined';
export default UsersQuarantined;
